import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import filterTypes from "data/filter-types";
import { closeCustomModal, openCustomModal } from "views/lib/components/modals";
import { getList } from "actions/chargers/rent/actions";
import { Link } from "react-router-dom";

const PowerBankRentHistory = ({
                                userId,
                                list,
                                getList,
                              }) => {
  useEffect(() => {
    getList(0, 1000, "start,DESC", [{
      fieldName: "user",
      fieldValue: userId,
      searchOperation: filterTypes.EQUALS.value
    }]);
  }, [getList, userId]);

  return (
    <div style={{ overflowX: "auto" }}>
      <table className="table table-hover table-bordered table-striped table-align-middle table-sm mb-0">
        <thead>
        <tr>
          <th>ID</th>
          <th>Power Bank</th>
          <th>Scan</th>
          <th>Start</th>
          <th>End</th>
          <th>Start Station</th>
          <th>End Station</th>
          <th>Amount</th>
          <th>Billing Amount</th>
          <th>Payment Status</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        {((list && list.content) || []).map(item => (
          <tr key={item.id}>
            <td>
              {item.id}
            </td>
            <td>
              {item.powerBank}
            </td>
            <td>
              {item.scan ? moment(item.scan)
                .format("HH:mm YYYY-MM-DD") : "N/A"}
            </td>
            <td>
              {item.start ? moment(item.start)
                .format("HH:mm YYYY-MM-DD") : "N/A"}
            </td>
            <td>
              {item.end ? moment(item.end)
                .format("HH:mm YYYY-MM-DD") : "N/A"}
            </td>
            <td>
              {item.startStationQR ? <Link to={`/chargers/stations/list/${item.startStationQR}`}>
                {item.startStationQR}
              </Link> : "N/A"}
            </td>
            <td>
              {item.endStationQR ? <Link to={`/chargers/stations/list/${item.endStationQR}`}>
                {item.endStationQR}
              </Link> : "N/A"}
            </td>
            <td>{item.payment && item.payment.amount ? item.payment.amount : "N/A"}</td>
            <td>{item.payment && item.payment.billingAmount ? item.payment.billingAmount : "N/A"}</td>
            <td>{item.payment && item.payment.status ? item.payment.status : "N/A"}</td>
            <td>
              <div className="btn-group">
                <button
                  className="btn btn-sm btn-warning"
                  title="Tets"
                  onClick={() => {
                  }}
                >
                  test
                </button>
              </div>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  list: state.powerBankRent.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(getList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(PowerBankRentHistory);



// WEBPACK FOOTER //
// ./src/views/pages/users/power-bank-rent-history.js